/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
  nodeId: ZodTypes.Id,
  sinceSeconds: z.coerce.number().positive(),
});

export const DownloadClusterNodeLogs = {
  id: 'cluster-node-logs.get',
  tag: 'Cluster',
  summary: 'Get cluster node logs',
  description: 'Retrieve the storage logs of a cluster node',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/node/${params.nodeId}/logs/${params.sinceSeconds}`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.any(),
        },
      },
    },
  },
} as const satisfies Endpoint;
